import React, {useEffect, useState} from 'react';
import UModal from "ubs-framework/v2/UModal/NewUModal";
import UButton from "ubs-framework/v2/UButton";
import {onLogout} from "../../../store/actions";
import {checkCookie} from "ubs-framework/v2/common/function";
import {useSelector} from "react-redux";

const CongratulationsModal = (props) => {
    const _ORG_ID = useSelector(e => e.common.orgId);
    /**
     * props are used
     * onSubmit,
     * onClose,
     * isHeaderShow, default visible
     * footer -  default visible
     * hideHeader - default visible
     * hideCancel - default visible
     * cancelType - default "Cancel"
     * submitType - default submit
     * title -
     * subTitle -
     * */

    const [seconds, setSeconds] = useState(10);

    useEffect(() => {
        if (props?.isAutoLogout) {
            if (seconds > 0) {
                const timer = setTimeout(() => setSeconds(seconds - 1), 1000);
                return () => clearTimeout(timer); // Cleanup timeout
            } else {
                if(checkCookie("ubs_token"))onLogout(true, _ORG_ID)
            }
        }
    }, [seconds]);

    return (<UModal
        open={true}
        isHeaderShow={props?.hideHeader ? false : true}
        maxWidth={670}
        onClose={() => props?.onClose()}
        name=""
        // className='u_new_template'
        footer={props?.footer ? props?.footer
            :<div className="u_row  u_pr-15 u_flex u_content-end">
                {props?.hideCancel ? ""
                :<div className="u_col-3">
                    <UButton variant="white" type={props?.cancelType ? props?.cancelType : "Cancel"} onClick={() => props?.onClose()}/>
                </div>}
            <div className="u_col-3">
                <UButton  variant="blue" type={props?.submitType ? props?.submitType :"submit"} onClick={() => props?.onSubmit()}/>
            </div>
        </div>}
    >
        {/*<div className="u_flex u_content-center u_align-center" style={{height:"300px"}}>*/}
        <div className="u_flex u_content-center u_align-center u_p-15" >
            <div className="">
                <img className="u_m-auto" src="/images/survey-submit.png" alt="Thanks You" style={{height:"190px" , width:"190px", margin:"auto"}}/>
                <div className="u_m-auto  u_text-center">
                    <h5 className="u_mb-10 u_color-green">{props?.title || "Thank You!"}</h5>
                    <p className="u_mb-15 u_small-font">{props?.subTitle || "Your submission has been received."}</p>
                    {props?.isAutoLogout && <p className="u_color-red u_small-font"> Auto logout out in {seconds || "0"} Seconds...</p>}
                </div>
            </div>
        </div>
    </UModal>)
}
export default CongratulationsModal


